const i = (d) => {
  const r = (e) => d((t) => ({ ...t, xendit: { ...t.xendit, ...e } }));
  return {
    cardHolderName: "",
    setCardHolderName: (e) => r({ cardHolderName: e }),
    cardNumber: "",
    setCardNumber: (e) => r({ cardNumber: e }),
    expiryMonth: "",
    setExpiryMonth: (e) => r({ expiryMonth: e }),
    expiryYear: "",
    setExpiryYear: (e) => r({ expiryYear: e }),
    cvc: "",
    setCvc: (e) => r({ cvc: e }),
    formInvalid: !0,
    setFormInvalid: (e) => r({ formInvalid: e })
  };
};
export {
  i as createXenditSlice
};
